import { useSearchParams } from 'react-router-dom'
import { useBreadcrumb } from '../hooks/useBreadcrumb'
import { FaBox, FaShip, FaBoxes } from 'react-icons/fa'
import { PageHeader } from '../components/common'
import LclOrderModule from '../components/order/LclOrderModule'
import FclOrderModule from '../components/order/FclOrderModule'

const TABS = [
  { key: 'lcl', label: '拼柜下单', icon: FaShip },
  { key: 'fcl', label: '整柜下单', icon: FaBoxes },
]

export default function OrderCreatePage() {
  const breadcrumb = useBreadcrumb()
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeTab = TABS.some((t) => t.key === tabParam) ? tabParam : 'lcl'

  const handleTabChange = (key) => {
    setSearchParams(key === 'lcl' ? {} : { tab: key })
  }

  return (
    <div>
      <PageHeader
        icon={FaBox}
        title="订单下单"
        subtitle="拼柜下单与整柜下单，一站式办理"
        breadcrumb={breadcrumb}
      />

      <div className="container py-8">
        {/* 模块 Tab 切换（参考运费评估页分段切换样式） */}
        {/* 小屏两个 Tab 各占一半并收窄内边距：原 px-6 + gap-3 + 图标 在 320px 下正好
            超出每格 144px，「拼柜下单」会折成两行。 */}
        <div className="flex justify-center mb-8">
          <div className="flex w-full sm:inline-flex sm:w-auto bg-gray-100 rounded-lg p-1">
            {TABS.map((tab) => {
              const Icon = tab.icon
              const isActive = activeTab === tab.key
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => handleTabChange(tab.key)}
                  className={`flex flex-1 sm:flex-none items-center justify-center gap-2 sm:gap-3 px-3 sm:px-6 py-3 rounded-lg font-medium whitespace-nowrap transition-all ${
                    isActive
                      ? 'bg-white text-primary-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-5 h-5 shrink-0" />
                  {tab.label}
                </button>
              )
            })}
          </div>
        </div>

        {activeTab === 'lcl' ? <LclOrderModule /> : <FclOrderModule />}
      </div>
    </div>
  )
}
